import { compact } from "lodash";
import { Helmet } from "react-helmet";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";

interface PageTitleProps {
  title: string;
}

export const PageTitle = ({ title }: PageTitleProps) => {
  const { currentCommunity } = useCurrentCommunityContext();
  const fullTitle = compact([title, currentCommunity?.name]).join(" | ");
  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
};
